import React from 'react';
import { OperatorSheet } from './OperatorSheet';
import { Button } from '../../../components/ui/Button';

/**
 * "Ese código es más de una cosa: ¿cuál?". Each option is a whole-width
 * button; choosing one sends the same action again with it.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {string} [props.title='¿Cuál es?']
 * @param {string} [props.message]
 * @param {Array<{id: number|string, title: string, subtitle?: string, badge?: string|null}>} props.options
 * @param {(id: number|string) => void} props.onChoose
 * @param {() => void} props.onClose
 * @param {boolean} [props.busy]
 * @param {string} [props.testId='candidates-sheet']
 */
export const CandidatesSheet = ({
  isOpen,
  title = '¿Cuál es?',
  message,
  options,
  onChoose,
  onClose,
  busy = false,
  testId = 'candidates-sheet',
}) => (
  <OperatorSheet isOpen={isOpen} onClose={onClose} title={title} testId={testId} busy={busy}>
    <div className="space-y-4">
      {message && <p className="text-sm text-text-secondary text-center">{message}</p>}
      <ul className="space-y-2">
        {(options || []).map((option) => (
          <li key={String(option.id)}>
            <Button
              variant="choice"
              data-testid="candidate-option"
              data-candidate-id={option.id}
              disabled={busy}
              onClick={() => onChoose(option.id)}
            >
              <span className="flex items-center justify-between gap-3">
                <span className="min-w-0">
                  <span className="block font-semibold text-ninja-dark dark:text-white">{option.title}</span>
                  {option.subtitle && <span className="block text-sm text-text-secondary">{option.subtitle}</span>}
                </span>
                {option.badge && (
                  <span className="shrink-0 rounded-full bg-ninja-green px-2.5 py-0.5 text-xs font-semibold text-white">
                    {option.badge}
                  </span>
                )}
              </span>
            </Button>
          </li>
        ))}
      </ul>
      <Button variant="ghost" size="lg" fullWidth onClick={onClose} disabled={busy}>
        Cancelar
      </Button>
    </div>
  </OperatorSheet>
);
